import React from 'react';
import {Title, TitleLevel, TitleSize} from 'components/ui/Title';

import './TelegramAction.scss';

const TelegramAction = ({background = 'light'}) => {
  return (
    <div className={`telegram-action telegram-action_${background}-bg`}>
      <Title
        extraClassName="telegram-action__title"
        level={TitleLevel.H3}
        size={TitleSize.H3}
      >
        Получите расчёт в&nbsp;Telegram
      </Title>

      <div className="telegram-action__button_wrapper">
        <p className="telegram-action__tooltip">
          Наш бот уточнит детали, сделает расчёт, ответит на&nbsp;вопросы. Если
          нужно, свяжет с&nbsp;менеджером в&nbsp;чате.
        </p>

        <a href="https://t.me/handsrubot" className="telegram-action__button">
          telegram
        </a>
      </div>
    </div>
  );
};

export default TelegramAction;
